const {db} = require('./firebase');

// # ==============================================
// # Пример схемы данных
// {
//     "users": {
//         "userId": {
//             "name": "John",
//             "surname": "Doe"
//         }
//     },
//     "planets": {
//         "planetId": {
//             "name": "Mars",
//             "surfaceTexture": "link",
//             "cloudTexture": "link",

//             "_playlists": { //  сложенные коллекции должны начинать с _ иначе это будет map
//                 "playlistId": {
//                     "auraColor": "coral",
//                     "name": "playlist name"
//                 }
//             }
//         }
//     }
// }
// # ==============================================

async function asyncForEach(array, callback) {
    for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
    }
}

export default function loadData(dataSchema) {
    try {

        const resolveDocument = async (doc, path) => {
            const output = {};
            await asyncForEach(Object.keys(doc), async key => {

                if (key.startsWith('_')) await resolveCollection({name: key.slice(1), content: doc[key]}, path);
                else  output[key] = doc[key];      
            });

            return output;
        }

        const resolveCollection = (col, path='') => {
            if (typeof col.content !== 'object') throw new Error(`Incorrect declaration - ${col}`);

            asyncForEach(Object.keys(col.content), async doc => {
                if (col.name.startsWith('_'))  col.name= col.name.slice(1);

                const colPath = `${path}/${col.name}`;
                const docPath = `${colPath}/${doc}`;
               
                const docContent = await resolveDocument(col.content[doc], docPath);

                await db.collection(colPath).doc(doc).set(docContent);
                
            })

        };

        asyncForEach(Object.keys(dataSchema), async col => {
            resolveCollection({name:col, content: dataSchema[col]});
        });

        return {error: false, message: 'Данные добавлены успешно'}
  
    } catch (err) {
        return {error: true, message: 'Произошка ошибка'}
    }
}